import { AxiosService } from '../../axios/axios.service.ts';
import { OpenAISuggestion, TSuggestionsRequest, TSuggestionsResponse } from './AI.types.ts';

export const suggestionsService = {
  generateSuggestions: async function (chatId: string, request: TSuggestionsRequest): Promise<OpenAISuggestion[]> {
    try {
      const response = await AxiosService.post<TSuggestionsRequest, TSuggestionsResponse>(
        `/ai/chats/${chatId}/suggestions`,
        request,
        {
          isLegacy: false,
        }
      );

      console.log(response);

      return Promise.resolve(response.suggestions);
    } catch (error) {
      console.error('Error in SuggestionsService:', error);
      return Promise.resolve([]);
    }
  }
};
